const carouselItems = [
  {
    title: '顶流恋情全记录：从密会到公开的时间线',
    desc: '深度梳理某顶流艺人过去半年的秘密恋情线索，从未公开照片到知情人爆料，完整还原事件全貌。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20romantic%20timeline%20visual%20with%20warm%20golden%20and%20deep%20crimson%20tones%2C%20luxurious%20editorial%20spread%20aesthetic%2C%20soft%20glowing%20heart%20motifs%2C%20dark%20elegant%20background%20with%20subtle%20texture%2C%20magazine%20cover%20style%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '独家专题',
  },
  {
    title: '综艺选秀黑幕大起底：票数造假的完整证据链',
    desc: '多位圈内人士实名提供证据，揭露热门选秀节目背后复杂的资本运作与票数操纵体系。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20with%20layered%20geometric%20forms%20and%20hidden%20patterns%2C%20deep%20red%20and%20black%20tones%2C%20investigative%20journalism%20aesthetic%2C%20mysterious%20cinematic%20lighting%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '深度调查',
  },
  {
    title: '影视圈税务风暴：多家公司被列入稽查名单',
    desc: '持续追踪影视行业税务专项整治行动，汇总涉案公司、艺人与最新稽查进展。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20storm%20concept%20with%20dramatic%20dark%20clouds%20and%20golden%20light%20breaking%20through%2C%20serious%20editorial%20mood%2C%20deep%20burgundy%20and%20amber%20tones%2C%20cinematic%20composition%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '追踪报道',
  },
  {
    title: '网红经济泡沫破裂：头部主播集体转型背后的真相',
    desc: '深度分析直播带货行业从巅峰到低谷的全过程，揭示流量造假、数据注水等行业乱象。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20bubble%20bursting%20visual%20with%20fragmented%20digital%20elements%20on%20dark%20background%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20dramatic%20editorial%20composition%2C%20luxurious%20textured%20surface%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '行业观察',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度追踪报道，还原事件完整面貌</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.img}
                  alt={`吃瓜爆料焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading={i >= 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-[10px] font-bold mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1.5 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-background-200/80 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}